export const USERS_FETCHED = 'USERS_FETCHED';
export const USERS_DELETE = 'USERS_DELETE';
